import { Card, CardContent, Grid, IconButton,    
    LinearProgress, TextField, Tooltip, Select,
    FormControl, InputLabel,MenuItem
} from "@mui/material";
import React, {useEffect, useState} from "react";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaToken} from "../../funciones/ClienteAxios";
import {useNavigate} from "react-router-dom";
import {isValidEmail, successToast, warningToast} from "../../Generales/Tools";
import axios from 'axios';
import {Search as SearchIcon} from "@mui/icons-material";
import ReplayIcon from '@mui/icons-material/Replay';
import TableUsers from "./TableUsers";
import NewEditUsu from "./NewEditUsu";

  const listEstatus=[
    {Id:-1, descr:"Sin Filtro"},
    {Id:0, descr:"Estatus Inactivo"},
    {Id:1, descr:"Estatus Activo"}
  ]

const Usuario = () => {

    const source = axios.CancelToken.source();
    const usuId = localStorage.getItem('UsuId');
    const history = useNavigate();
    const Dispvo = localStorage.getItem('Dispvo');
    const auxDispV = Dispvo.length >= 12 ? Dispvo : '451224452121'
    const [usuarios, setUsuarios] = useState([]);
    const [tipoError, setTipoError] = useState('')
    const [espera, setEspera] = useState(false)    
    const [selectedRow, setSelectedRow] = useState([])
    const [listTipo, setListTipo] = useState([])
    const [filtro, setFiltro] = useState({cadena:"", tipo:0, estatus:-1, especial:0})  
    const [modalAbierto, setModalAbierto] = useState(false);    
    const [recarga, setRecarga] = useState(false); 
    const {cadena, tipo, estatus, especial} = filtro

    useEffect(() => {
        getListUsu()    
        listarTipo()
       // listarTipo()
       // clearCache()
    }, [])

    useEffect(() => {
        if (filtro.length!==0) {
            getListUsu()    
        }else{
            setUsuarios([])
        }
               
    }, [recarga])  

    function listarTipo() {
        const data = qs.stringify({
            Usuario: usuId,
            idDispositivo: '45vf2d1vdf21d2f'
        });

        const url = "usuario-tipo-list";

        function respuesta(response) {
            if (response[0].Id !== -1) {
                const filtrado= response.filter((tipos)=>tipos.Id !==0)
                setListTipo(filtrado)     
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history,source);
    }

    function getListUsu() {
        const data = qs.stringify({
            //Usuario: usuId,
            //Cadena: filtro,
            usuario:usuId,
            status:estatus,
            tipo:tipo,
            puesto:especial === 2 ? cadena : "",
            nombre:especial === 1 ? cadena : "",
            idDispositivo: '45vf2d1vdf21d2f'
        });

        const url = "usuario/v2/list";

        function respuesta(response) {
            if (response[0].Id !== -1) {
                setUsuarios(response)           
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history,source);
    }

    function editarEstatus(row) {
        const data = qs.stringify({
            idUsuario: row.Id,
            Status: row.Status,
            idDispositivo: auxDispV
        });

        const url = "usuario-editar-status";

        function respuesta(response) {
            if (response.respuesta === 1) {
                successToast('El estatus de ' + row.Nombre + ' se edito correctamente.')
            } else {
                warningToast('Ocurrio un error.')
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history,source);
    }

    const Buscar = () => {
        setRecarga(!recarga)
        //let aux = usuarios.filter((item) => item.Nombre.toLowerCase().includes(filtro.toLowerCase()))
        //setUsuarios(aux)
    }

    const Refrescar = () => {
        setFiltro('')
    }

    const abrirModalNuevo = (event) => {
        event.preventDefault()
        setModalAbierto(true)              
    }
 
    const handleEditarEstatus = (id) => {
        const row = usuarios.find(x => x.Id === id)
        setSelectedRow(row)
        //setRegistro({...registro, status: row.Status === 1 ? 0 : 1})
        if(row.Status === 1){
            row.Status = 0
        }else{
            row.Status = 1
        }
       // console.log(row);
         editarEstatus(row)
        const posicion = usuarios.findIndex((element) => element.Id === id)
        usuarios.splice(posicion, 1, row)
    }
    
    const handleFiltro = (event) => {
     
        setFiltro({...filtro, [event.target.name]: event.target.value});
    }

    const onChangeFiltroTxt = e => {
        setFiltro({ ...filtro, [e.target.name]: e.target.value, cadena:"", })
    };

    const handleFiltroTxt = (e) => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            setFiltro({ ...filtro,cadena:e.target.value})
        }
    }

   const modNvo = modalAbierto ?<NewEditUsu modalAbierto={modalAbierto} setModalAbierto={setModalAbierto} 
                                    getListUsu={getListUsu}/>:null

    return (<>
        <Grid item xs={12}>
            {modNvo}
            <Card>
                <CardContent>
                    <Grid container alignItems={'center'} justifyContent={'flex-start'}>
                        <Grid item sx={{width:"13rem", marginRight:".5rem"}} >
                            <FormControl fullWidth size="small"  error={tipoError !== '' ? true : false} >
                                <InputLabel id="tipo">Tipo </InputLabel>
                                <Select
                                //helperText={nameError}
                                    labelId="tipo" id="tipo" name="tipo" 
                                    value={tipo} label="Tipo" onChange={handleFiltro}
                                >
                                    <MenuItem value={0} key={1} >{"Sin Filtro"}</MenuItem>
                                    {listTipo.length !== 0 ? 
                                        listTipo.map((element, index) =>    
                                            <MenuItem key={index+1} value={element.Id}>{element.Nom}</MenuItem>) 
                                    :   <MenuItem value={-1}>Sin Datos</MenuItem>}
                                </Select>
                            </FormControl>                           
                        </Grid>
                        <Grid item sx={{width:"10rem", marginRight:".5rem"}} >
                            <FormControl fullWidth size="small"  >
                                <InputLabel id="estatus">Estatus</InputLabel>
                                <Select
                                //helperText={nameError}
                                    labelId="estatus" id="estatus" name="estatus" 
                                    value={estatus} label="Estatus" onChange={handleFiltro}
                                >
                                    {listEstatus.length !== 0 ? 
                                        listEstatus.map((element, index) =>
                                            <MenuItem key={index} value={element.Id}>{element.descr}</MenuItem>) 
                                    :   <MenuItem value={-1}>Sin Datos</MenuItem>}
                                </Select>
                            </FormControl>                           
                        </Grid>
                        <Grid item>
                            <FormControl size="small" sx={{width:"10rem" , marginRight:".5rem"}}>
                                <InputLabel htmlFor="age-native-simple" size="small">Filtro por Texto</InputLabel>
                                <Select   size="small"  label="Filtro por Texto"
                                    value={especial} onChange={onChangeFiltroTxt} 
                                    inputProps={{ name: 'especial', id: 'especialSecl',}}
                                >                                    
                                    
                                    <MenuItem value={0} key={1} >Sin Filtro</MenuItem>                                    
                                    <MenuItem value={1} key={2} >Nombre</MenuItem>                                    
                                    <MenuItem value={2} key={3} >Puesto</MenuItem>                                    
                                </Select>
                            </FormControl>
                        </Grid>
                        {especial !==0 ?
                        <Grid item>
                            <TextField variant={'outlined'} name={'cadena'} size={'small'}
                                label={especial===1? 'Buscar por Nombre':"Buscar por Puesto"} 
                                value={cadena} onChange={handleFiltroTxt}
                            />
                        </Grid>
                        :null}
                        <Grid item>
                        <Tooltip title={'Buscar'}>
                            <IconButton color="primary" size="small" component="span" onClick={Buscar}>
                                <SearchIcon/>
                            </IconButton>
                        </Tooltip>
                        </Grid>
                        {/* <Grid item>
                            <Tooltip title={'Refrescar tabla'}>
                            <IconButton color="primary" size="small" component="span" onClick={Refrescar}>
                                <ReplayIcon/>
                            </IconButton>
                            </Tooltip>
                        </Grid> */}
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
        <Grid item xs={12}>
            {espera ? <LinearProgress/> 
            : ( usuarios.length!==0 ? 
                <TableUsers abrirModalNuevo={abrirModalNuevo} usuarios={usuarios} 
                    handleEditarEstatus={handleEditarEstatus} getListUsu={getListUsu}/>
                :null)}
        </Grid>
    </>);
};
export default Usuario;